/* Block container - generic block styling */
.block-container {
  padding: var(--mantine-spacing-md);
  border-radius: var(--mantine-radius-md);
}

.block-error {
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-sm);
  border: 1px solid var(--mantine-color-dark-4);
  border-radius: var(--mantine-radius-sm);
}

.block-error-title {
  margin-bottom: var(--mantine-spacing-xs);
  color: var(--mantine-color-dark-2);
}

.block-error-message {
  color: var(--mantine-color-dark-2);
}

.block-error-hint {
  margin-top: var(--mantine-spacing-xs);
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-dark-2);
}

/* Block title - used in various block types */
.block-title {
  margin-bottom: var(--mantine-spacing-sm);
  font-size: var(--mantine-font-size-md);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
  color: var(--mantine-color-dark-0);
}

/* Alert-based components - font size override for Mantine Alert */
.data-pending {
  font-size: var(--mantine-font-size-sm);
}

.empty-data {
  font-size: var(--mantine-font-size-sm);
}

/* Loading shimmer container */
.loading-shimmer {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
  padding: var(--mantine-spacing-md);
}

/* Shimmer loading width pattern - creates visual variety */
.shimmer-row-1 {
  width: 100%;
}
.shimmer-row-2 {
  width: 80%;
}
.shimmer-row-3 {
  width: 90%;
}
.shimmer-row-4 {
  width: 70%;
}
.shimmer-row-5 {
  width: 85%;
}

/* Alert-based BlockError - override for Mantine Alert component */
.alert-block-error {
  font-size: var(--mantine-font-size-sm);
}

/* Container query breakpoints for grid items */
/* Components can use these hooks or write their own @container grid-cell queries */

/* Small cell: compact layout, minimal padding */
@container grid-cell (max-width: 200px) {
  .grid-item-compact {
    padding: var(--mantine-spacing-xs);
  }
}

/* Medium cell: standard layout */
@container grid-cell (min-width: 201px) and (max-width: 400px) {
  .grid-item-standard {
    padding: var(--mantine-spacing-sm);
  }
}

/* Large cell: expanded layout with more breathing room */
@container grid-cell (min-width: 401px) {
  .grid-item-expanded {
    padding: var(--mantine-spacing-md);
  }
}

/* NOTE: Height-based container queries removed. KPI centering handled by flexbox within components.
   @container grid-cell (min-height: X) not supported with container-type: inline-size. */
